import LegalModals from "./LegalModals.tsx";
import LegalTexts from "./LegalTexts.tsx";

const LegalBlock = () => {
    return (
        <>
            <div className="mb-55">
                <LegalTexts />
                <LegalModals />
            </div>
        </>
    )
}

export default LegalBlock;
